import { render, staticRenderFns } from "./PortalTextarea.vue?vue&type=template&id=0c21201d&scoped=true&"
import script from "./PortalTextarea.vue?vue&type=script&lang=ts&"
export * from "./PortalTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c21201d",
  null
  
)

export default component.exports